export class TicketApprovalCommand {
  ticketId: string;
  approver: string;
  approverEmail: string;
  comments: string;

  constructor(ticketId: string, approver: string, approverEmail: string, comments: string) {
    this.ticketId = ticketId;
    this.approver = approver;
    this.approverEmail = approverEmail;
    this.comments = comments;
  }
}
